import type * as ngCore from '@angular/core'

import * as routeBound from '../route-bound'

import * as aliases from './aliases'
import * as dev from './dev'
import * as dynamicEcs from './dynamic-ecs'
import * as endUser from './end-user'
import * as models from './models'
import * as treeEditor from './tree-editor'

export { aliases, dev, dynamicEcs, endUser, models, treeEditor }

export function provideEntityCollections(): ngCore.Provider[] {
  return [
    routeBound.Registry.provideDestroyable(aliases.Feature),
    dev.actions.Api,
    routeBound.Registry.provideDestroyable(dev.actions.Collection),
    dev.pages.Api,
    dev.pages.assistant.Api,
    routeBound.Registry.provideDestroyable(dev.pages.Collection),
    dev.widgets.Api,
    routeBound.Registry.provideDestroyable(dev.widgets.Collection),
    routeBound.Registry.provideDestroyable(dynamicEcs.Feature),
    endUser.currentRendering.ApiService,
    endUser.currentRendering.actions.ApiService,
    endUser.currentRendering.page.ApiService,
    endUser.currentRendering.segments.ApiService,
    endUser.currentRendering.widgets.ApiService,
    routeBound.Registry.provideDestroyable(endUser.currentRendering.Feature),
    routeBound.Registry.provideDestroyable(treeEditor.Feature),
  ]
}
